
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Wenn man drei Tage braucht, ist der Effekt auf die Verbreitung von Sars-CoV-2
praktisch gleich null (siehe Grafik). Wenn man hingegen `}<strong parentName="p">{`sofort handelt, ist
der Effekt deutlich`}</strong>{`. Dafür ist der Beitrag einer Tracing-App gemäss einem
`}<a parentName="p" {...{
        "href": "https://cmmid.github.io/topics/covid19/reports/bbc_contact_tracing.pdf"
      }}>{`Paper`}</a>{`
des Epidemiologen Adam Kucharski entscheidend.`}</p>
    <p>{`«Es könnte sogar sein», erklärt der Epidemiologe und EPFL-Professor Marcel
Salathé, «dass eines Tages Proximity Tracing genügen wird, um die Epidemie unter
Kontrolle zu halten.»`}</p>
    <p>{`Er selbst geht davon aus, dass es für den gewünschten Effekt genügen würde, wenn
`}<strong parentName="p">{`60 Prozent der Schweizer Bevölkerung`}</strong>{` eine solche App installieren. Obwohl
mehr als neun von zehn Schweizern täglich ein Smartphone benutzen, ist dies ein
ambitioniertes Ziel.`}</p>
    <p>{`In Singapur wird schon seit dem 18. März eine ähnliche Proximity Tracing App
eingesetzt. Sie wurde aber nur von 20 Prozent der Bevölkerung installiert – dies
ist ungenügend. Weltweit haben schon `}<strong parentName="p">{`mehr als 35 Länder solche Apps`}</strong>{` im
Einsatz oder in Planung – viele davon haben jedoch Schwächen, sei es, weil sie
technische Probleme aufweisen, oder weil sie zu stark in die Privatsphäre
eingreifen.`}</p>
    <p>{`Marcel Salathé, eine treibende Kraft hinter der Schweizer Proximity Tracing App,
ist überzeugt dass der Schweizer Weg der richtige ist: «Man kann digitales
Contact Tracing so aufbauen, dass es aus epidemiologischer Sicht genügt, ohne
die Privatsphäre in Gefahr zu bringen.» Die Nationale Ethikkommission und der
Eidgenössische Datenschutzbeauftragte haben bereits grünes Licht gegeben.`}</p>
    <p>{`Am Ende diene eine solche App nur einem Zweck, und zwar der Unterstützung der
Ermittlung von Kontaktpersonen vor Ort durch Spezialisten. «Diese Experten
wissen, was zu tun ist – wer wann getestet werden kann und wer in Quarantäne
soll», sagt Salathé.`}</p>
    <h3>{`Wann kann ich die App installieren?`}</h3>
    <p>{`Laut dem
`}<a parentName="p" {...{
        "href": "https://www.bag.admin.ch/bag/de/home/krankheiten/ausbrueche-epidemien-pandemien/aktuelle-ausbrueche-epidemien/novel-cov/swisscovid-app-und-contact-tracing.html"
      }}>{`Bundesamt für Gesundheit (BAG)`}</a>{`
soll die Schweizer App `}<strong parentName="p">{`vom 25. Juni an`}</strong>{` in den App Stores verfügbar sein. Das
BAG arbeitet eng mit der EPFL und der ETH Zürich zusammen. Das Design der App
basiert auf dem sogenannten `}<a parentName="p" {...{
        "href": "https://github.com/DP-3T/documents"
      }}>{`DP-3T-Konzept`}</a>{`.
Mit diesem dezentralen Modell kann nicht rekonstruiert werden, wer wem zu
welchem Zeitpunkt begegnet ist – und auch nicht wo. Die Daten jedes Nutzers sind
nur auf dem eigenen Smartphone gespeichert. Es gibt also keine zentrale
Datenbank. Nach langem Zögern haben sich schliesslich auch Deutschland und
Grossbritannien für diese Lösung entschieden.`}</p>
    <p>{`Lesen Sie auch:
`}<a parentName="p" {...{
        "href": "https://www.tagesanzeiger.ch/wie-die-schweizer-corona-app-zum-weltstandard-wurde-748550512463"
      }}>{`So entstand die Tracing-App - Wie die Schweizer Corona-App zum Weltstandard wurde`}</a></p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;